<template>
  <div class="PaB-company-info">
    <div class="PaB-company__logo" v-if="venueInfo.logo_medium">
      <img :src="venueInfo.logo_medium" alt="">
    </div>
    <div class="PaB-company__details">
      <h2>{{venueInfo.name}}</h2>
      <p>{{venueInfo.address}}</p>
    </div>
  </div>
</template>

<script>

export default {
  computed: {
    venueInfo () {
      return this.$store.state.venue.info
    }
  }
}
</script>

<style lang="scss" scoped>
.PaB-company-info {
  display: flex;
  flex-direction: row;
  align-content: center;
}
.PaB-company__logo {
  width: 50px;
  height: 50px;
  margin-right: 12px;

  img {
    width: 100%;
    height: auto;
  }
  svg {
    width: 100%;
    height: 100%;
  }
}
.PaB-company__details {
  flex: 1 1 auto;
  h2 {
    font-size: 16px;
    font-weight: bold;
    margin: 0 0 5px 0;
  }
  p {
    font-size: 14px;
    margin: 0;
  }
}
</style>
